module.exports = __webpack_public_path__ + "static/img/exploit4.8beae963.png";